<template>
  <div class="Exporthk6">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk6(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk6") }}
        </v-btn> -->
         <download-excel
              :data = "papardatahk6"
              type="csv"
              name="hk6.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk6") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk6"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk6",
  setup() {},
  props: [
    "papardatahk6",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      {text: "Bil", value: "Bil"},
      {text: "HID", value: "HID"},
      {text: "BNO", value: "BNO"},
      {text: "Pusingan", value: "Pusingan"},
      {text: "S", value: "S"},
      {text: "NG", value: "NG"},
      {text: "DP", value: "DP"},
      {text: "DB", value: "DB"},
      {text: "BP", value: "BP"},
      {text: "ST", value: "ST"},
      {text: "NOIR", value: "NOIR"},
      {text: "NOAIR", value: "NOAIR"},
      // {text: "KAW", value: "KAW"},
      // {text: "Bulan", value: "Bulan"},
      // {text: "Tahun", value: "Tahun"},
      // {text: "BPK", value: "BPK"},
      // {text: "IDBPK", value: "IDBPK"},
      {text: "HK6PK", value: "HK6PK"},
      {text: "HK6PN", value: "HK6PN"},
      {text: "HK6S26", value: "HK6S26"},
      {text: "HK6M", value: "HK6M"},
      {text: "HK6S38", value: "HK6S38"},
      {text: "HK6S39", value: "HK6S39"},
      {text: "HK6B1", value: "HK6B1"},
      {text: "HK6B2", value: "HK6B2"},
      {text: "HK6A1", value: "HK6A1"},
      {text: "HK6A2", value: "HK6A2"},
      {text: "HK6A3", value: "HK6A3"},
      {text: "HK6A4", value: "HK6A4"},
      {text: "HK6C1", value: "HK6C1"},
      {text: "HK6C2", value: "HK6C2"},
      {text: "HK6C3", value: "HK6C3"},
      {text: "HK6C4", value: "HK6C4"},
      {text: "HK6C5", value: "HK6C5"},
      {text: "HK6INCS21e", value: "HK6INCS21e"},
      {text: "HK621ei", value: "HK621ei"},
      {text: "HK621eii", value: "HK621eii"},
      {text: "HK621eiii", value: "HK621eiii"},
      {text: "HK6INCS21ei", value: "HK6INCS21ei"},
      {text: "HK6INCS21eii", value: "HK6INCS21eii"},
      {text: "HK6INCS21eiii", value: "HK6INCS21eiii"},
      {text: "HK6KL", value: "HK6KL"},
      // {text: "dateMula", value: "dateMula"},
      // {text: "dateTamat", value: "dateTamat"},
    ],
  }),
  methods: {
    async exportexcelhk6(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk6serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>